import { createStoreRoutes } from './utils/storeLevelRoutesUtil';
import { ERouteContext } from './types';

const portalLevelStoreRoutes = (defaultStorePage: string) => {
  return createStoreRoutes(
    'store/:publisherId',
    defaultStorePage,
    ERouteContext.PORTAL_LEVEL_STORE,

  );
};

export default portalLevelStoreRoutes; 